import { Pipe, PipeTransform } from '@angular/core';
import { IDatePlace } from '../models/location.model';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'dateResume',pure:false })
export class DateResumePipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(datesPlaces: IDatePlace[],upperCase:boolean) {
    return this.dateService.resumeDatesPlaces(datesPlaces);
  }
}